import { Drawer, List } from 'antd';
import classNames from 'classnames';
import { AkamLogoCheckIcon, AkamLogoTextIcon, CloseXIcon, InstagramIcon, TelegramIcon } from 'icons';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { globalConst } from 'modules/global';

interface IProps {
  open: boolean;
  onClose: () => void;
  navItems: { label?: string; href: string; isNew?: boolean }[];
}

const MobileDrawer: React.FC<IProps> = ({ open, onClose, navItems }) => {
  const { pathname, locale = 'uz' } = useRouter();
  const t = globalConst.extraTranslation.footer[locale as 'uz' | 'ru'];
  const tHeader = globalConst.extraTranslation.header[locale as 'uz' | 'ru'];

  return (
    <Drawer
      footer={
        <>
          <div className="mr-5">
            <h3 className="text-md mb-4 font-medium">{t.contact_us}</h3>
            <div className="space-y-3 text-sm">
              <div>
                <p className="text-xs text-gray-400">{t.contact}: </p>
                {/* eslint-disable-next-line i18next/no-literal-string */}
                <Link href="tel:+998933868775" target="_blank" className="!font-medium !text-black">
                  +998 93 386 87 75
                </Link>
              </div>
              <div>
                <p className="text-xs text-gray-400">{t.address}:</p>
                {/* eslint-disable-next-line i18next/no-literal-string */}
                <span className="!font-medium !text-black"> Toshkent, ko'cha. Аxmad Donish, 20А 100180</span>
              </div>
            </div>
          </div>

          {/* Social */}
          <div className="my-5">
            <h3 className="mb-4 text-sm font-medium text-gray-500">{t.social}</h3>
            <div className="flex items-center gap-2">
              <Link href="https://www.instagram.com/akam.uz/" target="_blank">
                <span className="text-black">
                  {/* eslint-disable-next-line i18next/no-literal-string */}
                  <InstagramIcon />
                </span>
              </Link>
              <Link href="https://t.me/akamuz" target="_blank">
                <span className="text-black">
                  {/* eslint-disable-next-line i18next/no-literal-string */}
                  <TelegramIcon width="21" />
                </span>
              </Link>
            </div>
          </div>
        </>
      }
      closeIcon={false}
      width="21rem"
      extra={
        <div onClick={onClose} className="flex cursor-pointer items-center justify-center rounded-full bg-gray-800 p-1">
          <CloseXIcon size="12" />
        </div>
      }
      title={
        <Link href="/">
          <div className="flex items-center space-x-2 text-xl font-bold text-black">
            <AkamLogoCheckIcon />
            <AkamLogoTextIcon />
          </div>
        </Link>
      }
      placement="left"
      onClose={onClose}
      open={open}
    >
      <List
        dataSource={navItems}
        renderItem={item => {
          const isActive = item.href === '/' ? pathname === '/' : pathname.startsWith(item.href);

          return (
            <List.Item>
              <Link
                href={item.href}
                className={classNames(`block flex w-full items-center text-base`, {
                  '!font-medium !text-green-500': isActive,
                  '!text-gray-800': !isActive
                })}
                onClick={onClose}
              >
                {item.label}
                {item.isNew && (
                  <span className="relative -top-1.5 right-0 rounded-full bg-green-500 px-2 py-0.5 text-[0.625rem] font-medium text-white">
                    {tHeader.yangi}
                  </span>
                )}
              </Link>
            </List.Item>
          );
        }}
      />
    </Drawer>
  );
};

export default MobileDrawer;
